import { render, staticRenderFns } from "./vt-combo-select-label-renderer.vue?vue&type=template&id=d7ac5872&scoped=true&"
import script from "./vt-combo-select-label-renderer.ts?vue&type=script&lang=ts&"
export * from "./vt-combo-select-label-renderer.ts?vue&type=script&lang=ts&"
import style0 from "./vt-combo-select-label-renderer.scss?vue&type=style&index=0&id=d7ac5872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ac5872",
  null
  
)

export default component.exports